const megaMenu = () => {
  const siteHeader = document.querySelector(".js-site-header");

  /**
   *
   * @param {*} parent - hoveredMenu
   * @param {*} hovered - menuAttribute
   * @param {*} target - targetMenu
   * @param {*} targeted - targetAttribute
   */
  const menuItems = (parent, hovered, target, targeted, value) => {
    var menu = document.querySelector(parent);
    if (null === menu) {
      return;
    }
    var menuItems = Array.from(menu.querySelectorAll("[" + hovered + "]"));
    // HOVERED MENU ITEMS
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener("mouseover", (e) => {
        var sitesMenuOpened = document.body.classList.contains("-site-menu-open");
        console.log('SITEMENU ===', sitesMenuOpened)
        var hoveredItemDataAtt = menuItem.getAttribute(hovered);

        if (menu.classList.contains("js-top-nav")) {
          var menuContainer = document.querySelector(".main-nav-dropdown-wrap");

          // NOTE: late edtion: the 'contact us' link is an exception. This should not trigger the menu if hovered
          //console.log('menuItems', 'currentterget', e.currentTarget.parentNode);
          if (e.currentTarget.parentNode.classList.contains("no-children") || sitesMenuOpened) {
            // Don't display the mega menu! Or hide it if its already open
            menuContainer.classList.remove("show");
            document.body.classList.remove("-menu-opened");
            siteHeader.classList.remove("-menu-opened");
          } else {
            // Display mega menu
            menuContainer.classList.add("show");
            document.body.classList.add("-menu-opened");
            siteHeader.classList.add("-menu-opened");

            var relatedMenuCard = document.querySelector(
              `[data-menu-card='${hoveredItemDataAtt}']`
            );
            if (relatedMenuCard) {
              // hide all others
              hideRelatedMenuCards();

              relatedMenuCard.classList.add("-show");
            }
          }
        }

        // TARGET MENU ITEMS
        var targetMenus = Array.from(document.querySelectorAll(target));
        targetMenus.forEach((targetMenu) => {
          var targetMenuItems = Array.from(
            targetMenu.querySelectorAll(targeted)
          );
          //console.log('targetMenuItems', targetMenuItems);
          targetMenuItems.forEach((targetMenuItem) => {
            var targetMenuItemId = targetMenuItem.getAttribute("data-" + value);

            if (targetMenuItemId == hoveredItemDataAtt) {
              hideMenuItems(".js-mega-col-1", targetMenuItemId, parent);
              hideMenuItems(".js-mega-col-2", targetMenuItemId, parent);
              hideMenuItems(".js-mega-col-3", targetMenuItemId, parent);

              // Hide all menucards
              if (menu.classList.contains("js-mega-col-2")) {
                hideRelatedMenuCards();
              }
              targetMenuItem.classList.add("-show");
            }
          });
        });
      });
    });

    // hide all 3rd column items when a second col item is hovered (and that 2nd col item does not have any children)
    const hideThirdColItems = () => {
      var col2 = document.querySelector(".js-mega-col-2");
      var col3 = document.querySelector(".js-mega-col-3");
      col2.addEventListener("mouseover", function (e) {
        //console.log('target', e.target);
        if (
          e.target.parentNode.matches(
            ".nav-item-description:not(.has-children)"
          )
        ) {
          col3Items = col3.querySelectorAll(".nav-item-link");
          col3Items.forEach((col3Item) => {
            col3Item.classList.remove("-show");
          });
        }
      });
    };
    hideThirdColItems();

    const hideMenuItems = (targetcol, topLevelDataId, parent) => {
      var _targetcol = document.querySelector(targetcol);
      if (parent == ".js-mega-col-2") {
        _targetcol = document.querySelector(".js-mega-col-3");
      }
      var items = Array.from(_targetcol.querySelectorAll("[data-description]"));
      items.forEach((item) => {
        var id = item.getAttribute("data-description");
        //console.log('MENU-HIDE', id)
        if (id != topLevelDataId) {
          //console.log('MENU-HIDE', item);
          item.classList.remove("-show");
        }
      });
    };
  };

  const hideRelatedMenuCards = () => {
    const cardsContainer = document.querySelector(".parent-items__image-cards");
    const cards = Array.from(
      cardsContainer.querySelectorAll(".parent-items__image-card")
    );
    cards.forEach((card) => {
      //console.log('MENU-CARD', card);
      card.classList.remove("-show");
    });
  };

  // Top level
  menuItems(
    ".js-top-nav",
    "data-nav-description",
    ".js-mega-col",
    ".nav-item-description",
    "description"
  );
  // Second level tier 2
  menuItems(
    ".js-mega-col-2",
    "data-description2",
    ".js-mega-col-3",
    ".nav-item-link",
    "description"
  );
};
megaMenu();

const bodyClick = (selector, selector2, parent, className) => {
  var elem = document.querySelector(parent);
  document.body.addEventListener("mouseover", (e) => {
    if (!e.target.closest(selector) && !e.target.closest(selector2)) {
      elem.classList.remove(className);
      document
        .querySelector(".js-site-header")
        .classList.remove("-menu-opened");
      document.body.classList.remove("-menu-opened");
      document.body.classList.remove("-site-menu-open");
    }
  });
};
bodyClick(
  ".main-nav-dropdown-wrap",
  ".main-nav",
  ".main-nav-dropdown-wrap",
  "show"
);
bodyClick(
  ".main-nav-dropdown-wrap",
  ".main-nav",
  ".main-nav-dropdown-wrap__sites-menu",
  "-open"
);
